import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import Header from "../../components/ui/Header";
import Icon from "../../components/AppIcon";
import TimelineItem from "./components/TimelineItem";
import CareerHighlights from "./components/CareerHighlights";
import SkillEvolution from "./components/SkillEvolution";

const ExperienceTimeline = () => {
  const experiences = [
    {
      id: 101,
      company: "Paramaya Technology Services",
      companyLogo: "https://paramayatech.com/wp-content/uploads/2022/09/12.png",
      role: "React Developer",
      type: "Full-time",
      location: "On-site",
      startDate: "July 2025",
      endDate: null,
      teamSize: "5 developers",
      description:
        "Currently working on a logistics management mobile application using React Native. Developing features for real-time tracking, delivery management, and user interactions while collaborating with backend APIs built with .Net Core and MS SQL Server.",
      technologies: [
        "React Native",
        "JavaScript",
        "Bootstrap",
        "CSS",
        ".Net Core",
        "ASP.NET",
        "C#",
        "MSSQL Server",
      ],
      achievements: [
        // "Implementing real-time logistics tracking features.",
        "Designing responsive mobile interfaces for delivery management.",
        "Integrating backend APIs for seamless data flow between mobile and server.",
      ],
      projects: [
        {
          name: "Logistics Management Mobile App",
          description:
            "A mobile application to manage logistics operations, deliveries.",
          //  and real-time tracking for Paramaya Technology Services.",
          technologies: [
            "React Native",
            "Node.js",
            "Express",
            "MongoDB",
            "Bootstrap",
          ],
        },
      ],
      // testimonial: {
      //   content:
      //     "Currently developing advanced mobile features for the logistics management system, demonstrating expertise in React Native and full-stack integration.",
      //   author: "Yash Pal",
      //   role: "Developer",
      //   avatar: "https://randomuser.me/api/portraits/men/99.jpg",
      // },
    },
    {
      id: 102,
      company: "Personal & Internship Projects",
      companyLogo: "https://paramayatech.com/wp-content/uploads/2022/09/12.png",
      role: "Full Stack Developer Intern",
      type: "Personal Project / Internship",
      location: "Remote / On-site",
      startDate: "Jan 2025",
      endDate: "July 2025",
      teamSize: "Solo",
      description:
        "Worked on multiple projects including a text utility web application, a full-featured user management system, internship tasks at Paramaya Technology Services, and the company's website development. Gained experience in building responsive frontends, backends, and integrating databases with real-world applications.",
      technologies: [
        "React",
        "Bootstrap",
        "CSS",
        "Node.js",
        "Express",
        "MongoDB",
        "TypeScript",
        "JavaScript",
      ],
      achievements: [
        "Developed a responsive and user-friendly text utility application with real-time analysis features.",
        "Implemented a full-stack user management system with role-based access control.",
        "Contributed to internship projects, improving frontend components and backend API integration.",
        "Developed the Paramaya Technology Services website using React, Bootstrap, and TypeScript.",
        "Learned and applied industry-standard workflows, version control, and team collaboration.",
      ],
      projects: [
        {
          name: "Paramaya Technology Services Website",
          description:
            "Developed a responsive corporate website for Paramaya Technology Services using React, Bootstrap, and TypeScript, showcasing services, team, and projects.",
          technologies: [
            "React",
            "Bootstrap",
            "TypeScript",
            "CSS",
            "JavaScript",
          ],
        },
        {
          name: "Internship Web Development Tasks",
          description:
            "Contributed to web application development during internship at Paramaya Technology Services, assisting with frontend components, backend APIs, and database integration.",
          technologies: ["React", "Bootstrap", "Node.js", "Express", "MongoDB"],
        },
        {
          name: "User Role Management System",
          description:
            "A full-stack system to manage users, roles, and permissions with role-based access control. Developed as a solo project using React, Node.js, Express, and MongoDB.",
          technologies: ["React", "Bootstrap", "Node.js", "Express", "MongoDB"],
          link: "https://github.com/Yashya14/User-Role-Management",
        },
        {
          name: "Text Utils Web App",
          description:
            "A personal project to manipulate and analyze text efficiently with a clean UI. Features include converting text to uppercase/lowercase, clearing text, copying text, and displaying word/character counts and reading time.",
          technologies: ["React", "Bootstrap", "CSS", "JavaScript"],
          link: "https://textutilsyash.netlify.app/",
        },
      ],
      // testimonial: {
      //   content:
      //     "Demonstrated strong full-stack development skills across personal projects, internship work, and corporate website development, delivering scalable and responsive web applications.",
      //   author: "Yash Pal",
      //   role: "Developer",
      //   avatar: "https://randomuser.me/api/portraits/men/99.jpg",
      // },
    },
    // {
    //   id: 3,
    //   company: "StartupVenture",
    //   companyLogo:
    //     "https://images.unsplash.com/photo-1551434678-e076c223a692?w=100&h=100&fit=crop&crop=center",
    //   role: "Frontend Developer",
    //   type: "Full-time",
    //   location: "Remote",
    //   startDate: "Jun 2020",
    //   endDate: "Feb 2021",
    //   teamSize: "6 developers",
    //   description:
    //     "Focused on building responsive and interactive user interfaces for a fast-growing SaaS platform. Worked closely with designers and product managers to implement pixel-perfect designs.",
    //   technologies: [
    //     "React",
    //     "JavaScript",
    //     "CSS3",
    //     "Sass",
    //     "Webpack",
    //     "Jest",
    //     "Figma",
    //     "Git",
    //   ],
    //   achievements: [
    //     "Increased user engagement by 35% through improved UI/UX implementation",
    //     "Reduced page load times by 45% through performance optimization",
    //     "Built responsive design system used across 15+ application screens",
    //     "Implemented accessibility features achieving WCAG 2.1 AA compliance",
    //     "Collaborated with design team to create seamless user experiences",
    //   ],
    //   projects: [
    //     {
    //       name: "SaaS Dashboard Interface",
    //       description:
    //         "Modern dashboard interface with complex data visualizations and interactions",
    //       technologies: ["React", "Chart.js", "Sass", "Webpack"],
    //     },
    //     {
    //       name: "Mobile-First Landing Pages",
    //       description:
    //         "Series of conversion-optimized landing pages with A/B testing capabilities",
    //       technologies: ["React", "CSS3", "JavaScript", "Google Analytics"],
    //     },
    //   ],
    //   testimonial: {
    //     content:
    //       "Incredible attention to detail and user experience. Transformed our product's interface into something truly exceptional.",
    //     author: "Emily Rodriguez",
    //     role: "Product Manager",
    //     avatar: "https://randomuser.me/api/portraits/women/28.jpg",
    //   },
    // },
    ,
  ];

  useEffect(() => {
    document.title = "Experience Timeline - Yash Pal";
  }, []);

  return (
    <div className="min-h-screen bg-background">
      <Header />
      <main className="pt-16">
        {/* Hero Section */}
        <section className="py-20 lg:py-32 px-6 lg:px-8">
          <div className="max-w-4xl mx-auto text-center">
            <motion.div
              initial={{ opacity: 0, y: 30 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.8 }}
            >
              <div className="flex items-center justify-center mb-6">
                <div className="w-16 h-16 bg-gradient-to-br from-conversion-accent to-trust-builder rounded-2xl flex items-center justify-center">
                  <Icon name="Clock" size={32} color="white" strokeWidth={2} />
                </div>
              </div>

              <h1 className="text-4xl lg:text-6xl font-bold text-foreground mb-6">
                Experience
                <span className="text-conversion-accent"> Timeline</span>
              </h1>

              <p className="text-xl text-muted-foreground max-w-3xl mx-auto leading-relaxed">
                A journey through my career, showcasing growth, achievements,
                and the evolution of my technical expertise across different
                roles and organizations.
              </p>
            </motion.div>
          </div>
        </section>

        {/* Career Highlights */}
        {/* <section className="py-16 px-6 lg:px-8">
          <div className="max-w-7xl mx-auto">
            <CareerHighlights />
          </div>
        </section> */}

        {/* Skill Evolution */}
        {/* <section className="py-16 px-6 lg:px-8 bg-muted/20">
          <div className="max-w-7xl mx-auto">
            <SkillEvolution />
          </div>
        </section> */}

        {/* Experience Timeline */}
        <section className="py-20 px-6 lg:px-8">
          <div className="max-w-6xl mx-auto">
            <motion.div
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.6 }}
              className="text-center mb-16"
            >
              <h2 className="text-3xl lg:text-4xl font-bold text-foreground mb-4">
                {/* Professional  */}
                Journey
              </h2>
              <p className="text-lg text-muted-foreground max-w-2xl mx-auto">
                Detailed timeline of my career progression, key achievements,
                and the technologies I've mastered along the way
              </p>
            </motion.div>

            <div className="relative">
              {/* Desktop Timeline Line */}
              <div className="absolute left-1/2 transform -translate-x-1/2 w-0.5 bg-border h-full top-0 hidden lg:block" />

              {/* Mobile Timeline Line */}
              <div className="absolute left-4 w-0.5 bg-border h-full top-0 lg:hidden" />

              {experiences?.map((experience, index) => (
                <TimelineItem
                  key={experience?.id}
                  experience={experience}
                  index={index}
                  isLast={index === experiences?.length - 1}
                />
              ))}
            </div>
          </div>
        </section>

        {/* Call to Action */}
        <section className="py-20 px-6 lg:px-8 bg-gradient-to-br from-conversion-accent/5 to-trust-builder/5">
          <div className="max-w-4xl mx-auto text-center">
            <motion.div
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.6 }}
            >
              <h2 className="text-3xl lg:text-4xl font-bold text-foreground mb-6">
                Ready to Add Your Project to My Timeline?
              </h2>
              <p className="text-lg text-muted-foreground mb-8 max-w-2xl mx-auto">
                I'm always excited to take on new challenges and contribute to
                innovative projects. Let's discuss how my experience can benefit
                your team.
              </p>

              <div className="flex flex-col sm:flex-row gap-4 justify-center items-center">
                <Link to="/contact">
                  <motion.div
                    // href="mailto:contact@yash.com"
                    // href="/contact"
                    whileHover={{ scale: 1.05 }}
                    whileTap={{ scale: 0.95 }}
                    className="inline-flex items-center justify-content-center px-8 py-4 bg-conversion-accent hover:bg-conversion-accent/90 text-white font-semibold rounded-lg transition-smooth shadow-subtle text-center hover:shadow-elevation"
                  >
                    <Icon name="Mail" size={20} className="mr-2" />
                    Get In Touch
                  </motion.div>
                </Link>

                <Link to="/project-showcase-gallery">
                  <motion.div
                    whileHover={{ scale: 1.05 }}
                    whileTap={{ scale: 0.95 }}
                    className="inline-flex items-center px-8 py-4 bg-card border border-border hover:bg-muted/50 text-foreground font-semibold rounded-lg transition-smooth"
                  >
                    <Icon name="FolderOpen" size={20} className="mr-2" />
                    View My Projects
                  </motion.div>
                </Link>
              </div>
            </motion.div>
          </div>
        </section>
      </main>
      {/* Footer */}
      <footer className="py-12 px-6 lg:px-8 border-t border-border">
        <div className="max-w-7xl mx-auto">
          <div className="flex flex-col md:flex-row items-center justify-between">
            <div className="flex items-center mb-4 md:mb-0">
              <div className="w-8 h-8 bg-gradient-to-br from-conversion-accent to-trust-builder rounded-lg flex items-center justify-center mr-3">
                <Icon name="Code2" size={16} color="white" strokeWidth={2.5} />
              </div>
              <span className="text-foreground font-semibold">Yash Pal</span>
            </div>

            <div className="text-sm text-muted-foreground">
              © {new Date()?.getFullYear()} Yash Pal. Crafted with ❤️ and
              passion.
            </div>
          </div>
        </div>
      </footer>
    </div>
  );
};

export default ExperienceTimeline;
